module.exports = __webpack_public_path__ + "static/img/4ban.0941ad54.png";